<!-- 组织管理 -->
<template>
    <div class="business-content-main">
        <breadcrumb></breadcrumb>
        <el-container style="height: 650px">
            <el-header style="line-height: 60px">
                <el-row type="flex" :gutter="20" align="middle">
                    <el-col :span="24">
                        <el-button class="btn-primary" size="small" @click="addFormData" v-if="permission.add">添加部门</el-button>
                        <el-button class="btn-primary" size="small" @click="editFormData" v-if="permission.edit">编辑部门</el-button>
                        <el-button class="btn-primary" size="small" @click="delOrgS" v-if="permission.del">删除部门</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-container style="height: 100%">
                <el-aside :width="isShrink ? '0' : '15%'" height="100%" style="transition: all 0.3s">
                    <el-card class="box-card" style="padding: 25px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree
                            check-strictly
                            highlight-current
                            default-expand-all
                            :data="orgSearchData"
                            show-checkbox
                            ref="tree"
                            :filter-node-method="filterNode"
                            node-key="Id"
                            :props="treeProps"
                            @node-click="handleNodeClick"
                            @check="handleNodeCheck"
                        ></el-tree>
                    </el-card>
                </el-aside>
                <div class="shrink-out-view" @click="changeShrink">
                    <div class="shrink-in-view"><i class="el-icon-arrow-right" :class="{ active: !isShrink }"></i></div>
                </div>
                <el-main :width="isShrink ? '0' : '85%'" height="100%" style="padding-top: 0px; transition: all 0.3s">
                    <el-card class="box-card" style="padding: 50px; height: 100%">
                        <el-form ref="form" :model="orgformData" label-width="80px" :disabled="!isEdit">
                            <el-form-item label="部门名称">
                                <el-input v-model="orgformData.name"></el-input>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input v-model="orgformData.sortNo"></el-input>
                            </el-form-item>
                            <el-form-item label="上级部门">
                                <el-cascader
                                    style="width: 100%"
                                    :key="cascaderKey"
                                    v-model="orgformData.parentId"
                                    :options="orgSearchData"
                                    :props="cascaderProps"
                                    clearable
                                ></el-cascader>
                            </el-form-item>
                            <el-row>
                                <el-col :span="2">
                                    <el-button class="btn-primary" size="medium" @click="editOrganization">提交</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    name: '',
    components: { breadcrumb },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            isEdit: false,
            entpId: userMsg.EntpId,
            orgformData: {
                id: '',
                entpId: userMsg.EntpId,
                parentId: '',
                name: '',
                icon: '',
                sortNo: 0,
                operator: userMsg.EmployeeId
            },
            orgSearchData: [],
            cascaderKey: 0, //key值改变了，cascader就会重新渲染,以防切换数据时报错
            treeProps: {
                children: 'Childrens',
                label: 'Name'
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            ids: '',
            filterText: '',
            checkedKeys: [], //选中的节点id
            checkedNodes: [], //勾选中的节点
            permission: {},
            isShrink: false // 是否收缩状态
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.getOrgTree();
        this.permission = this.$util.getPermission('organizationalStructure');
        let shrinkStu = this.$util.getLocalStorage('organiShrinkStu');
        this.isShrink = shrinkStu * 1 === 1;
    },
    mounted() {},
    computed: {},
    methods: {
        // 改变收缩状态
        changeShrink() {
            this.isShrink = !this.isShrink;
            let value = !this.isShrink ? 0 : 1;
            this.$util.setLocalStorage('organiShrinkStu', value);
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            this.isEdit = false;
            if (data) {
                ++this.cascaderKey;
                this.orgformData = {
                    id: data.Id,
                    entpId: this.userMsg.EntpId,
                    parentId: data.ParentId == null ? '' : data.ParentId,
                    name: data.Name,
                    icon: '',
                    sortNo: data.SortNo,
                    operator: this.userMsg.EmployeeId
                };
            }
        },
        //共两个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象，包含 checkedNodes、checkedKeys、halfCheckedNodes、halfCheckedKeys 四个属性
        handleNodeCheck(data, checkData) {
            this.isEdit = false;
            if (checkData) {
                ++this.cascaderKey;
                this.orgformData = {
                    id: data.Id,
                    entpId: this.userMsg.EntpId,
                    parentId: data.ParentId == null ? '' : data.ParentId,
                    name: data.Name,
                    icon: '',
                    sortNo: data.SortNo,
                    operator: this.userMsg.EmployeeId
                };
                this.checkedNodes = checkData.checkedNodes;
                this.checkedKeys = checkData.checkedKeys;
            }
        },
        getOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTree'
                })
                .then(res => {
                    ++this.cascaderKey;
                    if (res.data) {
                        this.orgSearchData = this.getOrgSearchData(res.data);
                    }
                });
        },
        //递归获取组织数据，为了处理子级为空时，级联选择器出错的问题 edit by qdl 2020/8/6
        getOrgSearchData(data) {
            for (var i = 0; i < data.length; i++) {
                if (!data[i].Childrens||data[i].Childrens.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].Childrens = undefined;
                    // this.$delete(data[i], 'Childrens');
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getOrgSearchData(data[i].Childrens);
                }
            }
            return data;
        },
        editOrganization() {
            let that = this;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/EditOrganization',
                    data: that.orgformData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.orgformData.id = res.data;
                        that.$message({
                            type: 'success',
                            message: '保存成功'
                        });
                        that.getOrgTree();
                    } else {
                        this.$util.errorMsg(res.error_msg);
                    }
                })
                .catch(() => {});
        },
        delOrgS() {
            if (this.checkedKeys.length > 0) {
                this.ids = '';
                this.checkedKeys.forEach(element => {
                    if (this.ids != '') {
                        this.ids = this.ids + ',';
                    }
                    this.ids += element;
                });
            } else {
                this.$message({
                    type: 'warning',
                    message: '请勾选部门'
                });
                return;
            }
            this.$confirm('一经删除无法恢复,是否确认删除？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$util
                        .axiosPost({
                            url: '/api/EntpInfoManagement/DelOrgs?ids=' + this.ids
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                            }
                            this.getOrgTree();
                        });
                })
                .catch(action => {});
        },
        addFormData() {
            ++this.cascaderKey;
            this.clearFormData();
            this.isEdit = true;
        },
        editFormData() {
            if (!this.checkedNodes || this.checkedNodes.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '请勾选部门'
                });
                return;
            } else if (this.checkedNodes.length > 1) {
                this.$message({
                    type: 'warning',
                    message: '只能编辑一个部门'
                });
                return;
            }

            let checkedNode = { ...this.checkedNodes[0] };
            if (!checkedNode.Id) {
                this.$message({
                    type: 'warning',
                    message: '根目录不可修改'
                });
                return;
            }
            ++this.cascaderKey;
            this.orgformData = {
                id: checkedNode.Id,
                entpId: this.userMsg.EntpId,
                parentId: checkedNode.ParentId == null ? '' : checkedNode.ParentId,
                name: checkedNode.Name,
                icon: '',
                sortNo: checkedNode.SortNo,
                operator: this.userMsg.EmployeeId
            };
            this.isEdit = true;
        },
        clearFormData() {
            this.orgformData = {
                id: '',
                entpId: this.userMsg.EntpId,
                parentId: '',
                name: '',
                icon: '',
                sortNo: 0,
                operator: this.userMsg.EmployeeId
            };
        }
    }
};
</script>
<style lang="less">
.business-content-main .el-card::-webkit-scrollbar {
    display: none;
}
</style>
<style lang="less" scoped>
.treeClass {
    width: auto;
    height: auto;
    border: cadetblue 1px solid;
    padding: 20px;
}
.shrink-out-view {
    background-color: rgba(0, 0, 0, 0.075);
    display: flex;
    align-items: center;
    cursor: pointer;
}
.shrink-in-view {
    width: 100%;
    height: 30px;
    background-color: #409eff;
    border-radius: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    color: #fff;
}
.shrink-in-view .active {
    transform: rotate(-180deg);
}
</style>
